import { render, staticRenderFns } from "./PowerBI.vue?vue&type=template&id=4ba6bca6&scoped=true"
import script from "./PowerBI.vue?vue&type=script&lang=js"
export * from "./PowerBI.vue?vue&type=script&lang=js"
import style0 from "./PowerBI.vue?vue&type=style&index=0&id=4ba6bca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba6bca6",
  null
  
)

export default component.exports